import type { PageContent } from '@/shared/config/pages';
import type { FooterLinkAction } from './links';
import type { FooterArticleBlock, FooterArticleView } from '../model/types';

export const FOOTER_PAGE_TITLES = {
  guarantee: 'Гарантия честных цен',
  buyTour: 'Купить тур онлайн',
} as const;

export const GUARANTEE_CONTENT: FooterArticleBlock[] = [
  { type: 'heading', text: 'Гарантируем, что забронируем любой тур по цене туроператора или даже дешевле' },
  {
    type: 'description',
    text: 'Мы показываем актуальную стоимость туров без наценок. Благодаря большим объёмам продаж, мы получаем от ТО особые условия сотрудничества. Поэтому часто наши цены даже ниже, чем на сайте туроператора.',
  },
  {
    type: 'description',
    text: 'Когда туристы начинают планировать путешествие, они сравнивают цены на разных источниках. Это могут быть сайты туроператоров или сайты таких же метапоисковиков, как Травелата. Но мы уверены, что наши цены – не выше, а часто даже ниже. Поэтому нет необходимости идти куда-то ещё. Ведь тур мечты можно подобрать на нашем сайте по самой выгодной цене!',
  },
  {
    type: 'description',
    text: 'Если вы найдёте конкретный тур дешевле, чем у нас, мы вернём вам разницу в двойном размере.',
  },
  {
    type: 'description',
    text: 'Мы тщательно следим за тем, чтобы на сайте не было ошибок. Однако бывают случаи, когда туроператор передаёт неверную цену или появляется ошибка внутри нашего сайта. В таком случае мы всё равно компенсируем эту ошибку - не важно, кто виноват. Доверие клиентов стоит дорого - поэтому у нас только честные цены, и мы готовы это доказать.',
  },
  { type: 'heading', text: 'Что нужно сделать, чтобы вернуть разницу?' },
  {
    type: 'description',
    text: 'Забронируйте тур на сайте или в мобильном приложении Травелата. В комментариях укажите, что вы нашли тур дешевле. Добавьте ссылку на страницу с сайта туроператора или любого другого сайта с этим туром, цену тура и время, в которое эта цена была замечена. Лучше также добавить скриншот с нашего сайта и сайта туроператора.',
  },
  {
    type: 'description',
    text: 'Наш специалист изучит туры и подтвердит, что на другом сайте один и тот же тур стоит дешевле. И мы вернём вам разницу в стоимости в двойном размере. Разница вернётся на карту, по которой вы оплачивали тур на сайте Травелата.',
  },
  { type: 'heading', text: 'Подробные правила гарантии:' },
  { type: 'description', text: 'Гарантия лучшей цены актуальна при следующих условиях:' },
  {
    type: 'list',
    items: [
      'Турпродукты полностью совпадают – то есть одинаковые туроператор, город, количество туристов, даты и время вылета, количество ночей, авиакомпания, отель, тип номера, тип питания, наличие трансфера.',
      'Дата и время полностью совпадают. Обновите страницу нашего сайта с туром и обновите страницу другого сайта с этим туром более низкой стоимости. Затем можно сделать скриншот и приступать к бронированию.',
      'В финальную цену тура не входит персональная скидка, скидка по программе лояльности или скидка от туроператора или агентства.',
      'Цены должны быть указаны в рублях.',
      'Гарантия распространяется на цены, в которые включены все дополнительные сборы (топливные сборы и обязательные доплаты к турам).',
    ],
  },
];

export const BUY_TOUR_CONTENT: string = `
  <p>Нашими партнерами являются самые крупные и <a href="/rating" rel="external">надежные туроператоры</a>, поэтому вы можете быть уверены в качестве приобретенного тура. Кроме того, на сайте Travelata.ru можно купить тур по самым лучшим ценам – мы предоставляем вам возможность отправиться в путешествие с лучшим соотношением цена/качество от любого из 120 туроператоров.</p>
  <p>Наша компания учитывает интересы каждого клиента, и поэтому у нас можно подобрать отель для отдыха в тропических странах или на <a href="/ski" rel="external">горнолыжных курортах</a>, купить <a href="/tury" rel="external">горящий тур</a> по сниженной цене или <a href="/earlybooking" rel="external">забронировать путешествие заранее</a>. Мы предоставляем подробную информацию о каждом отеле – на сайте вы можете увидеть фотографии, подробное описание и отзывы реальных людей, а удобный <a href="/search" rel="external">поиск туров</a> поможет отсортировать доступные варианты по критериям.</p>
  <p>С Travelata вы можете планировать поездку так, как вам удобно – можете заказать туры онлайн через сайт, по телефону, а также с помощью мобильного приложения для смартфонов и планшетов. Опытные и компетентные специалисты нашей компании готовы помочь в приобретении тура 24 часа в сутки 7 дней в неделю – мы можем проконсультировать вас в любое время дня и ночи, если вы выбираете среди нескольких вариантов или хотите узнать подробнее о стране, курорте или отеле.</p>
  <p>Мы предоставляем возможность экономить свое время, оплачивая отдых онлайн. Наш магазин туров работает по технологии оплаты через <a href="https://travelata.ru" rel="external">защищенный</a> банковский портал, что исключает вероятность постороннего доступа к платежным данным пластиковых карт. К тому же, оплачивая онлайн, вы приобретаете тур почти мгновенно, опережая остальных желающих купить его. После подтверждения бронирования все необходимые для поездки документы отправляются по электронной почте и доступны в вашем личном кабинете на сайте, что избавляет от необходимости терять время на поездку в офис.</p>
  <p>Выбирая отдых с Travelata.ru, вы гарантированно получаете огромный выбор путешествий для отдыха, поэтому купить путевку у нас не сложнее, чем совершать покупки в любом онлайн магазине. Лучшие цены и первоклассное профессиональное обслуживание – гарантия вашего качественного отдыха.</p>
`;

export const BUY_TOUR_DEFAULT: PageContent = {
  title: 'Поиск туров онлайн - купить дешевые туры с вылетом из Москвы',
  label: 'Купить тур с вылетом из Москвы',
  content: BUY_TOUR_CONTENT,
};

export function resolveFooterArticlePage(
  action: FooterLinkAction,
  pageContent?: PageContent,
): FooterArticleView | null {
  if (action === 'guarantee') {
    return { headerTitle: FOOTER_PAGE_TITLES.guarantee, mainTitle: '', content: GUARANTEE_CONTENT };
  }
  if (action === 'buyTour' && pageContent) {
    return {
      headerTitle: FOOTER_PAGE_TITLES.buyTour,
      mainTitle: pageContent.title ?? '',
      content: pageContent.content ?? '',
    };
  }
  return null;
}
